export const AT_MENTION_TRIGGER_CHARACTER = '@';
export const AT_MENTION_CHANGE_SOURCE = 'AtMention';
export const AT_MENTION_ELEMENT_ID_PREFIX = 'OWAAM';
export const AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL = 'suggestedRecipients';
export const AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX = 'suggestedRecipient-';
